import { ConfiguredShow } from "components/admin/fixRouteBids/show";
import { viewContainer } from "helpers/redux";

export default viewContainer(ConfiguredShow, "organization-fix-route-bids");
